module.exports = __webpack_public_path__ + "static/media/bg_page98.131cd152.png";